import { useEffect, useState } from "react";

import Inbox from "components/fax/Inbox";
import SentFax from "components/fax/SentFax";
import Contacts from "components/fax/Contacts";

import {
  DeleteModal,
  EditSentFaxModal,
  FaxLogModal,
  WarnModal,
} from "components/ui-component/modals";
import { useAppDispatch } from "redux/hooks";
import {
  getFaxList,
  getContactList,
  getSentFaxList,
  getUserNumber
} from "redux/slice/faxSlice";


import {
  setInboxType,
  setSentType, setTab,
  useHideDelete,
  useHideDeleteIn,
  useNumber, useStatusfilter,
  useTab
} from "redux/slice/commanSlice";
import { baseUrl } from "API/baseURL";
import { DELETE_FAXES } from "API/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import { useAuth0 } from "@auth0/auth0-react";
import { message, Tabs, TabsProps } from "antd";
import CoverPage from "components/coverPage/CoverPage";
import SelectTheme from "components/SelectTheme/SelectTheme";
import MobileNewSidebarStyle from "components/layouts/MobileNewSidebar/MobileNewSidebar.style";
import useIsMobile from "hooks/useIsMobile";
import { onGetUserInfo } from "components/Helper/onGetUserInfo";
import Loader from "components/ui-component/loader/Loader";

const Fax = () => {
  const { user } = useAuth0();
  const [deleteId, setDeleteId] = useState<any>(null);
  const [faxLogs, setFaxLogs] = useState<any>(null);
  const [sentFaxData, setSentFaxData] = useState<any>(null);
  const [isWarn, setIsWarn] = useState<boolean>(false);
  const [isLoading, seIsLoading] = useState<boolean>(false);
  const [isUserValid, setIsUserValid] = useState<boolean | null>(null);

  const status_filter = useStatusfilter();
  const hide_deleted = useHideDelete();
  const hide_deletedIn = useHideDeleteIn();
  const number = useNumber();
  const isMobile = useIsMobile();

  const [inFilter, setInFilter] = useState<any>({
    page: 1,
    per_page: 10,
    search_query: "",
    order_by: "desc",
    hide_deleted: hide_deletedIn,
    hide_incomplete: "yes",
    start_date: undefined,
    end_date: undefined,
  });
  const [filter, setFilter] = useState<any>({
    page: 1,
    per_page: 10,
    search_query: "",
    order_by: "desc",
    status_filter: status_filter,
    hide_deleted: hide_deleted,
    start_date: undefined,
    end_date: undefined,
  });
  const [contactfilter, setContactFilter] = useState<{
    page: number;
    per_page: number;
    name_query: string;
    order_by: string;
  }>({
    page: 1,
    per_page: 10,
    name_query: "",
    order_by: "desc",
  });
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const activeTab = useTab();
  const location = useLocation();

  useEffect(() => {
    dispatch(setInboxType("All"));
    dispatch(setSentType("All"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const PageRender = () => {
    switch (activeTab) {
      case "fax":
        return (
          <SentFax
            setDeleteId={setDeleteId}
            setSentFaxData={setSentFaxData}
            setFilter={setFilter}
            filter={filter}
            setIsWarn={setIsWarn}
            isLoading={isLoading}
            setFaxLogs={setFaxLogs}
          />
        );
      case "contacts":
        return (
          <Contacts
            setContactFilter={setContactFilter}
            contactfilter={contactfilter}
          />
        );
      case "cover-page":
        return (
          <CoverPage
            contactfilter={contactfilter}
            setContactFilter={setContactFilter}
          />
        );
      case "settings":
        return <SelectTheme />;

      default:
        return (
          <Inbox
            setDeleteId={setDeleteId}
            setSentFaxData={setSentFaxData}
            setFilter={setInFilter}
            filter={inFilter}
            setIsWarn={setIsWarn}
            isLoading={isLoading}
            setFaxLogs={setFaxLogs}
          />
        );
    }
  };

  const onGetUserNumber = async (number: string) => {
    try {
      await dispatch(getUserNumber(number)).unwrap();
    } catch (error: any) {
      console.log("Get USer number Err: --->", error?.message);
    }
  };

  useEffect(() => {
    (async () => {
      const valid = await onGetUserInfo(dispatch, user, navigation);
      setIsUserValid(valid);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(isUserValid){
      onGetUserNumber(number);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [number,isUserValid]);

  useEffect(() => {
    if (activeTab === "fax") onSentFaxListGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, number]);

  useEffect(() => {
    if (activeTab === "inbox") onFaxListGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inFilter, number]);

  useEffect(() => {
    if (activeTab === "contacts") onContactListGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactfilter, number]);

  const onFaxListGet = useDebouncedCallback(async () => {
    const userInfoOk = await onGetUserInfo(dispatch, user, navigation);
    if (!userInfoOk) return; 
    seIsLoading(true);
    try {
      const params = {
        ...inFilter,
        username: user?.email,
        phone_number: number,
        direction: "in",
      };
      await dispatch(getFaxList(params)).unwrap();
      seIsLoading(false);
    } catch (error: any) {
      seIsLoading(false);
      console.log("fax list get error -->", error?.message);
    }
  }, 500);

  const onContactListGet = useDebouncedCallback(async () => {
    const userInfoOk = await onGetUserInfo(dispatch, user, navigation);
    if (!userInfoOk) return; 
   
    seIsLoading(true);
    try {
      const params = {
        ...contactfilter,
      };
      await dispatch(getContactList(params)).unwrap();
      seIsLoading(false);
    } catch (error: any) {
      seIsLoading(false);
      console.log("contact list get error -->", error?.message);
    }
  }, 500);

  const onSentFaxListGet = useDebouncedCallback(async () => {
    const userInfoOk = await onGetUserInfo(dispatch, user, navigation);
    if (!userInfoOk) return;

    seIsLoading(true);
    try {
      const params = {
        ...filter,
        username: user?.email,
        phone_number: number,
        direction: "out",
      };
      if (params.status_filter === "all") delete params["status_filter"];
      await dispatch(getSentFaxList(params)).unwrap();
      seIsLoading(false);
    } catch (error: any) {
      seIsLoading(false);
      console.log("fax list get error -->", error?.message);
    }
  }, 500);

  const onDeleteFax = async (id: string) => {
    const userInfoOk = await onGetUserInfo(dispatch, user, navigation);
    if (!userInfoOk) return;

    seIsLoading(true);
    const data = [id];
    const accessToken = localStorage.getItem("accessToken");
    fetch(`${baseUrl}${DELETE_FAXES}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Request failed with status " + response.status);
        }
      })
      .then(() => {
        setDeleteId("");
        message.success("Fax deleted successfully");
        seIsLoading(false);
        if (activeTab === "inbox") onFaxListGet();
        if (activeTab === "fax") onSentFaxListGet();
        if (activeTab === "contacts") onContactListGet();
      })
      .catch((error) => {
        console.error("Error:", error);
        setDeleteId("");
        message.error("Fax can't be deleted");
        seIsLoading(false);
      });
  };

  const items: TabsProps["items"] = [
    {
      key: "inbox",
      label: "Inbox",
      children: (
        <Inbox
          setDeleteId={setDeleteId}
          setSentFaxData={setSentFaxData}
          setFilter={setInFilter}
          filter={inFilter}
          setIsWarn={setIsWarn}
          isLoading={isLoading}
          setFaxLogs={setFaxLogs}
        />
      ),
    },
    {
      key: "fax",
      label: "Sent Faxes",
      children: (
        <SentFax
          setDeleteId={setDeleteId}
          setSentFaxData={setSentFaxData}
          setFilter={setFilter}
          filter={filter}
          setIsWarn={setIsWarn}
          isLoading={isLoading}
          setFaxLogs={setFaxLogs}
        />
      ),
    },
    {
      key: "contacts",
      label: "Contacts",
      children: (
        <Contacts
          setContactFilter={setContactFilter}
          contactfilter={contactfilter}
        />
      ),
    },
    {
      key: "cover-page",
      label: "Cover Page",
      children: (
        <CoverPage
          contactfilter={contactfilter}
          setContactFilter={setContactFilter}
        />
      ),
    },
    {
      key: "settings",
      label: "Settings",
      children: <SelectTheme />,
    },
  ];

  if (isUserValid === null) return <Loader />;

  if (!isUserValid) {
    // Only the logout modal will show (handled globally)
    return null;
  }

  return (
    <>
      {isMobile ? (
        <div className="desktop-hide w-100 h-100">
          <MobileNewSidebarStyle className="h-100">
            <Tabs
              destroyOnHidden={true}
              activeKey={activeTab ?? "inbox"}
              items={items}
              onChange={(key: string) => {
                dispatch(setTab(key));
              }}
            />
          </MobileNewSidebarStyle>
        </div>
      ) : (
        <div className="mobile-hide w-100 h-100">{PageRender()}</div>
      )}

      <DeleteModal
        isLoading={isLoading}
        visible={!!deleteId}
        onCancelClick={() => setDeleteId(null)}
        onDoneClick={() => onDeleteFax(deleteId)}
        title="Are you sure you want to delete this fax?"
        content="This action cannot be undone. Deleting the fax will permanently remove all its content and cannot be recovered."
      />
      {!!sentFaxData && (
        <EditSentFaxModal
          visible={!!sentFaxData}
          setDeleteId={setDeleteId}
          setSentFaxData={setSentFaxData}
          onCancelClick={() => {
            setSentFaxData(null);
            if (activeTab === "inbox") onFaxListGet();
            if (activeTab === "fax") onSentFaxListGet();
            if (activeTab === "contacts") onContactListGet();
          }}
          data={sentFaxData}
        />
      )}
      <WarnModal
        visible={isWarn}
        onCancelClick={() => setIsWarn(false)}
        onDoneClick={() => setIsWarn(false)}
      />
      {faxLogs?.length ? (
        <FaxLogModal
          data={faxLogs}
          visible={faxLogs?.length}
          onCancelClick={() => setFaxLogs(null)}
        />
      ) : null}
    </>
  );
};
export default Fax;
